<template>
    <v-app>
        <v-app-bar flat app color="#2A4054" dark clipped-left v-if="currentRoute !== 'signin'" permanent>
            <v-app-bar-nav-icon class="white--text" @click="drawer = !drawer" large v-if="isUserAuth"
                permanent></v-app-bar-nav-icon>

            <v-spacer /><v-spacer />

            <v-toolbar-title>
                <div class="ml-2 text-h4 hidden-sm-and-down">Tablet Dashboard Management</div>
                <div class="ml-2 text-h5 hidden-md-and-up">Tablet Dashboard Management</div>
            </v-toolbar-title>

            <v-spacer />

            <v-icon
                v-if="environment !== 'production'"
                large
                class="white--text"
                :class="isOnline ? 'mr-4' : ''">
                mdi-dev-to
            </v-icon>

            <v-icon
                v-show="!isOnline"
                class="mx-4 white--text"
                large>
                mdi-cloud-off-outline
            </v-icon>

            <img src="@/assets/cobb.png" />
        </v-app-bar>

        <v-navigation-drawer id="tdm-navigation-drawer" v-model="drawer" dark width="250" app clipped color="#2A4054" v-if="currentRoute !== 'signin'" permanent>
            <v-container>
                <v-row>
                    <v-col>
                        <v-card color="transparent" flat>
                            <div style="text-align: center;">
                                <div>TDM</div>
                                <img src="@/assets/tdm.png" width="64px" alt="TDM" />
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <v-list style="padding: 0;">
                <v-list-item class="py-2 ma-1 ml-1 pl-1" to="/">
                    <v-icon class="mr-4">mdi-monitor-dashboard</v-icon>
                    <span>Dashboard</span>
                </v-list-item>
                <v-list-item class="py-2 ma-1 ml-1 pl-1" v-if="isAdmin" permanent>
                    <v-icon class="mr-4">mdi-hammer-wrench</v-icon>
                    <span>Sync Configuration</span>
                </v-list-item>
                <v-list-item class="py-2 ma-1 ml-1 pl-1 ml-10" to="/syncSchedule" v-if="isAdmin" permanent>
                    <v-icon class="mr-4">mdi-calendar-clock</v-icon>
                    <span>Schedule</span>
                </v-list-item>
                <v-list-item class="py-2 ma-1 ml-1 pl-1 ml-10" to="/syncTablet" v-if="isAdmin" permanent>
                    <v-icon class="mr-4">mdi-tablet</v-icon>
                    <span>Tablet</span>
                </v-list-item>
                <v-list-item class="py-2 ma-1 ml-1 pl-1" to="/syncManual" v-if="isAdmin" permanent>
                    <v-icon class="mr-4">mdi-sync</v-icon>
                    <span>Sync Manual</span>
                </v-list-item>
                <v-list-item class="py-2 ma-1 ml-1 pl-1" to="/admin" v-if="isAdmin" permanent>
                    <v-icon class="mr-4">mdi-wrench</v-icon>
                    <span>Administration</span>
                </v-list-item>
                <v-list-item class="py-2 ma-1 ml-1 pl-1" to="/settings">
                    <v-icon class="mr-4">mdi-cog</v-icon>
                    <span>Settings</span>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-main>
            <router-view></router-view>
        </v-main>

        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <tdm-notice v-model="notice.on" :text="notice.text" :color="notice.color" />
    </v-app>
</template>

<script>
import Notice from "@/components/Notice";
import { mapState } from "vuex";

export default {
    name: 'MainNavigation',
    components: {
        'tdm-notice': Notice
    },
    data() {
        return {
            environment: null,
            isLoading: false,
            drawer: true,
            isAdmin: false,
            isUserAuth: false,
            notice: { text: "", on: false, color: "info" }
        }
    },
    async created() {
        this.environment = process.env.VUE_APP_MODE;

        window.addEventListener('tdm-show-notice', this.addNotice);
        window.addEventListener('tdm-set-scrollbar-theme', this.changeScrolling);
        window.addEventListener('tdm-show-in-progress', this.showInProgress);
        this.changeScrolling();
        this.isAdmin = this.userRoles.some((role) => role.principalDisplayName == "TDM Admins");
    },
    beforeDestroyed() {
        window.removeEventListener('tdm-set-scrollbar-theme', this.changeScrolling);
    },
    methods: {
        addNotice(e) {
            this.notice = { ...e.detail };
        },
        changeScrolling() {
            let scrollbarColor;
            let trackColor;
            let handleColor;
            if (this.$vuetify.theme.dark) {
                scrollbarColor = "#424242";
                trackColor = "#424242";
                handleColor = "#595959";
            } else {
                scrollbarColor = '#E0E0E0';
                trackColor = '#E0E0E0';
                handleColor = '#A0A0A0';
            }

            const style = `
          ::-webkit-scrollbar {
            /*display: none;*/
            width: 14px;
            background:${scrollbarColor};
          }
          ::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px ${trackColor}; 
          }
          ::-webkit-scrollbar-thumb {
            background: ${handleColor}; 
          }
          /* Chrome, Safari, Edge, Opera */
          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }`;
            const x = document.getElementById("scrollbarStyle");
            x.innerHTML = style;
        },
        showInProgress(e) {
            this.isLoading = e.detail.enabled;
        }
    },
    computed: {
        ...mapState(['userRoles','isOnline']),
        currentRoute() {
            return this.$route.name;
        }
    }
};
</script>